import { useState } from 'react';
import { Sidebar } from './Sidebar';
import { TopBar } from './TopBar';
import { AdminToastHost, type AdminToast } from '../components/AdminToastHost';

export function AdminShell({
  currentPath,
  onNavigate,
  searchValue,
  onSearchChange,
  environmentLabel,
  environmentStatus,
  role,
  onLogout,
  banners,
  toasts,
  onToastDismiss,
  children,
}: {
  currentPath: string;
  onNavigate: (path: string) => void;
  searchValue: string;
  onSearchChange: (value: string) => void;
  environmentLabel: string;
  environmentStatus: string;
  role?: 'admin' | 'viewer' | null;
  onLogout: () => void;
  banners?: React.ReactNode;
  toasts?: AdminToast[];
  onToastDismiss?: (id: string) => void;
  children: React.ReactNode;
}) {
  const [mobileNavigationOpen, setMobileNavigationOpen] = useState(false);

  return (
    <div className="admin-shell">
      <Sidebar
        currentPath={currentPath}
        onNavigate={onNavigate}
        isOpen={mobileNavigationOpen}
        onClose={() => setMobileNavigationOpen(false)}
        role={role}
        onLogout={onLogout}
      />
      {mobileNavigationOpen ? (
        <button
          type="button"
          className="admin-shell__backdrop"
          aria-label="Закрити меню"
          onClick={() => setMobileNavigationOpen(false)}
        />
      ) : null}
      <div className="admin-shell__main">
        <TopBar
          searchValue={searchValue}
          onSearchChange={onSearchChange}
          environmentLabel={environmentLabel}
          environmentStatus={environmentStatus}
          role={role}
          onLogout={onLogout}
          onOpenNavigation={() => setMobileNavigationOpen(true)}
        />
        <main className="admin-shell__content">
          {banners ? <div className="admin-stack admin-stack--tight">{banners}</div> : null}
          {children}
        </main>
        <AdminToastHost toasts={toasts || []} onDismiss={onToastDismiss || (() => {})} />
      </div>
    </div>
  );
}
